import FullWidthLayout from "@/layouts/FullWidthLayout";
import { KNotFound } from "kinnect-general";
import { Pageable } from "kinnect-mixins";

export default {
	name: "Error404Page",

	metaInfo: { title: "404 - Page Not Found" },

	mixins: [ Pageable ],

	render() {
		return <FullWidthLayout>
			<KNotFound></KNotFound>
		</FullWidthLayout>;
	}
};
